import { Select, Typography, Table } from "antd";
import { ColumnsType } from "antd/es/table";

import React, { useEffect, useState } from "react";

const formatData = (listItems: { fieldKey: string; fieldName: string }[]): T_Table[] => {
  return listItems.map((item, i) => ({
    index: i,
    db_field_name: item.fieldKey,
    label: item.fieldName,
  }));
};

const formatSelectOptions = (fileHeaders: string[]) => {
  return fileHeaders.map((header) => {
    return { label: header, value: header };
  });
};

const listItems = [
  { fieldName: "Business Name", fieldKey: "business_name" },
  { fieldName: "First Name", fieldKey: "first_name" },
  { fieldName: "Last Name", fieldKey: "last_name" },

  {
    fieldName: "Filed On",
    fieldKey: "filedOn",
  },
  {
    fieldName: "Published On",
    fieldKey: "publishedOn",
  },
  {
    fieldName: "Created On",
    fieldKey: "createdOn",
  },
  {
    fieldName: "Updated On",
    fieldKey: "updatedOn",
  },
  {
    fieldName: "Docket Updated On",
    fieldKey: "docketUpdatedOn",
  },
  {
    fieldName: "Key Number",
    fieldKey: "caseNumber",
  },
  {
    fieldName: "Court",
    fieldKey: "court",
  },
  {
    fieldName: "Judge",
    fieldKey: "judge",
  },
  {
    fieldName: "Plaintiff",
    fieldKey: "plaintiff",
  },
  {
    fieldName: "Plaintiff Lawyers",
    fieldKey: "plaintiffLawyers",
  },
  {
    fieldName: "Plaintiff Law Firm",
    fieldKey: "plaintiffLawFirm",
  },
  {
    fieldName: "Key Title / Defendant",
    fieldKey: "defendant",
  },
  {
    fieldName: "Defendant Lawyers",
    fieldKey: "defendantLawyers",
  },
  {
    fieldName: "Defendant Law Firm",
    fieldKey: "defendantLawFirm",
  },
  {
    fieldName: "Summary",
    fieldKey: "summary",
  },
  {
    fieldName: "Nature of Suit",
    fieldKey: "natureOfSuit",
  },
  {
    fieldName: "Nature of Suit ID",
    fieldKey: "natureOfSuitId",
  },
  {
    fieldName: "State",
    fieldKey: "state",
  },
  {
    fieldName: "City",
    fieldKey: "city",
  },
  { fieldName: "Case Type", fieldKey: "case_type" },
  { fieldName: "Issue", fieldKey: "issue" },
  { fieldName: "Amount", fieldKey: "amount" },
  { fieldName: "Facebook", fieldKey: "facebook" },
  { fieldName: "Linkedin", fieldKey: "linkedin" },
  { fieldName: "Email", fieldKey: "email" },
  { fieldName: "Phone", fieldKey: "phone" },
];
type T_Table = {
  index: number;
  db_field_name: string;
  label: string;
  mappedField?: string;
  preview?: string[];
};

const CaseMapping = ({
  fileHeader,
  previewData,
  setDynamicMappedData,
}: {
  fileHeader: string[];
  previewData: Record<string, string[]>;
  setDynamicMappedData: React.Dispatch<React.SetStateAction<Record<string, string>>>;
}) => {
  const [tableFormatData, setTableFormatData] = useState<T_Table[]>(formatData(listItems));
  const [headerOptions, setHeaderOptions] = useState(formatSelectOptions(fileHeader ?? []));
  const column: ColumnsType<T_Table> = [
    {
      key: "db_field",
      title: "Key",
      render: (value, record, index) => {
        return (
          <div className="flex flex-col">
            <Typography.Text>{record.label}</Typography.Text>
            {record.label === "Key Number" && (
              <Typography.Text className="text-red-500 text-sm">This field must be unique</Typography.Text>
            )}
          </div>
        );
      },
      width: 200,
    },
    {
      key: "mapped_field",
      title: "Mapped Field",
      render: (value, record, index) => {
        return (
          <Select
            showSearch
            style={{ width: "100%" }}
            options={headerOptions}
            allowClear
            onChange={(info: string) => handleOptionChange(info, record.db_field_name)}
            placeholder={`Select ${record.label}`}
          />
        );
      },
    },
    {
      key: "preview_data",
      title: "Available Example",
      render: (value, record, index) => {
        return (
          record.preview && <Typography.Text>{record.preview.filter(Boolean).join(", ")}</Typography.Text>
          //   record.preview.map((data, i) => {
          //     return <Typography.Text key={i}>{data}</Typography.Text>;
          //   })
        );
      },
    },
  ];
  const handleOptionChange = (info: string | undefined, db_field_name: string) => {
    setTableFormatData((prev) =>
      prev.map((item, i) =>
        item.db_field_name === db_field_name
          ? { ...item, mappedField: info, preview: previewData[info as string] || [] }
          : item,
      ),
    );
  };

  useEffect(() => {
    setDynamicMappedData(
      tableFormatData.reduce(
        (acc, zone, i) => {
          acc[listItems[i].fieldKey] = zone.mappedField || "";
          return acc;
        },
        {} as Record<string, string>,
      ),
    );
  }, [tableFormatData]);
  return (
    <div>
      <Table scroll={{ y: 500 }} columns={column} dataSource={tableFormatData} pagination={false} />
    </div>
  );
};

export default CaseMapping;
